import { useState, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import OrganizationService from '../services/organizationService';

/**
 * Custom hook to get the organization's timezone
 * @returns {Object} Object containing timezone and loading state
 */
export const useOrganizationTimezone = () => {
  const auth = useAuth();
  const [timezone, setTimezone] = useState('America/Mexico_City');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadOrganizationTimezone = async () => {
      const token = auth.user?.access_token;
      const userId = auth.user?.profile?.sub;
      
      if (!token || !userId) {
        setIsLoading(false);
        return;
      }
      
      try {
        const organization = await OrganizationService.getCurrentUserOrganization(userId, token);
        setTimezone(organization?.timezone || 'America/Mexico_City');
      } catch (error) {
        console.error('Error loading organization timezone:', error);
        setTimezone('America/Mexico_City');
      } finally {
        setIsLoading(false);
      }
    };

    loadOrganizationTimezone();
  }, [auth.user?.access_token, auth.user?.profile?.sub]);

  return { timezone, isLoading };
};

export default useOrganizationTimezone;
